"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

/**
 * WidgetTitle component for rendering widget titles with appropriate heading levels
 * Uses h2 for proper accessibility and semantic hierarchy
 */
var WidgetTitle = function WidgetTitle(_ref) {
  var content = _ref.content,
      className = _ref.className,
      style = _ref.style;
  if (!content) return null;
  return (0, _preact.h)("h2", {
    style: style,
    className: "widget-title widget__heading ".concat(className !== null && className !== void 0 ? className : '')
  }, content);
};

var _default = WidgetTitle;
exports.default = _default;